import React from 'react';
import { IconBase } from '../Base';
export const IconReset = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
            React.createElement("path", { d: "M9.99865 3.33374C6.63718 3.33425 3.80191 5.83727 3.38458 9.17274C2.96725 12.5082 5.09843 15.6326 8.35615 16.4613C11.6139 17.29 14.979 15.5637 16.2062 12.4343C17.4334 9.30484 16.1388 5.75126 13.1862 4.14457" }),
            React.createElement("path", { d: "M13.1885 6.70643V3.75977H16.1351" }))));
};
//# sourceMappingURL=Reset.js.map